import { render } from "./AddOrderBtn.vue?vue&type=template&id=f3fbd64a&scoped=true"
import script from "./AddOrderBtn.vue?vue&type=script&lang=js"
export * from "./AddOrderBtn.vue?vue&type=script&lang=js"

import "./AddOrderBtn.vue?vue&type=style&index=0&id=f3fbd64a&scoped=true&lang=css"

import exportComponent from "/builds/off-group-apps/personal-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3fbd64a"]])

export default __exports__